import { useRef, useState } from 'react';
import { useAuthUser, useSignOut } from 'react-auth-kit';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem, Avatar, IconButton } from '@mui/material';
import Cookies from 'js-cookie';
// components
import MenuPopover from '../../components/MenuPopover';
import { usePostLogout } from '../../hooks/query/auth';

// const MENU_OPTIONS = [
// 	{
// 		label: 'Home',
// 		icon: 'eva:home-fill',
// 		linkTo: '/',
// 	},
// 	{
// 		label: 'Profile',
// 		icon: 'eva:person-fill',
// 		linkTo: '#',
// 	},
// 	{
// 		label: 'Settings',
// 		icon: 'eva:settings-2-fill',
// 		linkTo: '#',
// 	},
// ];

export default function AccountPopover() {
	const anchorRef = useRef(null);

	const auth = useAuthUser();

	const signOut = useSignOut();

	const { mutate } = usePostLogout({
		onSuccess: () => {
			signOut();
		},
	});

	const [open, setOpen] = useState(null);

	const handleOpen = (event) => {
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};

	return (
		<>
			<IconButton
				ref={anchorRef}
				onClick={handleOpen}
				sx={{
					p: 0,
					...(open && {
						'&:before': {
							zIndex: 1,
							content: "''",
							width: '100%',
							height: '100%',
							borderRadius: '50%',
							position: 'absolute',
							bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
						},
					}),
				}}
			>
				<Avatar src={auth()?.user_profile} alt="photoURL" />
			</IconButton>

			<MenuPopover
				open={Boolean(open)}
				anchorEl={open}
				onClose={handleClose}
				sx={{
					p: 0,
					mt: 1.5,
					ml: 0.75,
					'& .MuiMenuItem-root': {
						typography: 'body2',
						borderRadius: 0.75,
					},
				}}
			>
				<Box sx={{ my: 1.5, px: 2.5 }}>
					<Typography variant="subtitle2" noWrap>
						{auth()?.fullname?.firstname}
					</Typography>
					<Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
						{auth()?.email}
					</Typography>
				</Box>

				<Divider sx={{ borderStyle: 'dashed' }} />

				{/* <Stack sx={{ p: 1 }}>
					{MENU_OPTIONS.map((option) => (
						<MenuItem
							key={option.label}
							to={option.linkTo}
							component={RouterLink}
							onClick={handleClose}
						>
							{option.label}
						</MenuItem>
					))}
				</Stack> */}

				<Divider sx={{ borderStyle: 'dashed' }} />

				<MenuItem
					onClick={() => {
						const refreshToken = Cookies.get('_auth_refresh');

						if (refreshToken) mutate(refreshToken);
					}}
					sx={{ m: 1 }}
				>
					Logout
				</MenuItem>
			</MenuPopover>
		</>
	);
}
